import EvaluationData from './EvaluationData';

export function getEvaluationDataWithException() {
    return new EvaluationData({
        entityId: 'INVALID_ENTITY_ID',
        experimentKey: {
            experimentId: 99991,
            experimentName: 'INVALID_EXPERIMENT_NAME'
        },
        experimentInstanceId: 99990,
        bucket: {
            bucketValue: 0,
            calculationType: {
                typeIdentifier: 'F'
            }
        },
        value: 0,
        exception: true
    });
}

export function getEmptyEvaluationData() {
    return new EvaluationData({});
}
